import Flex from '@components/Flex/Flex';
import { styled, TableCell } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  paddingTop: theme.spacing(10),
  width: '100%',
  flexDirection: 'row',
  position: 'relative',
  flexWrap: 'wrap',
  gap: theme.spacing(10),
}));

export const PortfolioContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  height: '35vh',
  minWidth: '35vw',
  [theme.breakpoints.down('md')]: {
    height: '30%',
    minWidth: '100%',
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(9, 6),
    textAlign: 'center',
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(7, 3),
  },
}));
